import { ModuleHubLayout } from "../../components/shell/ModuleHubLayout";
import { filterMarketplaceNavSections } from "../../config/navigation";
import { useAuth } from "../../stores/auth";

export function MarketplaceModuleLayout() {
  const { can, moduleEnabled } = useAuth();
  const sections = filterMarketplaceNavSections(can, moduleEnabled);

  return (
    <ModuleHubLayout
      title="Marketplace"
      subtitle="C2C listings, sellers, and sales"
      sections={sections}
    />
  );
}
